import {
    PENDING_STORE,
    FAIL_STORE,
    SUCCESS_STORE,
    PENDING_REGIONS,
    FAIL_REGIONS,
    SUCCESS_REGIONS,
    SUCCESS_DEPARTEMENTS,
    PENDING_DEPARTEMENTS,
    FAIL_DEPARTEMENTS,
    SUCCESS_ARRONDISSEMENTS,
    FAIL_ARRONDISSEMENTS,
    PENDING_ARRONDISSEMENTS, SUCCESS_ETABLISSEMENTS_ITEM, PENDING_ETABLISSEMENTS_ITEM, FAIL_ETABLISSEMENTS_ITEM
} from "../actions/types";

const initialState = {
    message: '',
    status: 'pending',
    status_regions: '',
    type: '',
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SUCCESS_STORE:
            return  {
                ...state,
                status: 'success',
                message: payload.message,
            };

        case PENDING_STORE:
            return  {
                ...state,
                status: 'pending',
                message: payload.message,
            };

        case FAIL_STORE:
            return  {
                ...state,
                status: 'fail',
                message: payload.message,
            };

        case SUCCESS_REGIONS:
            return  {
                ...state,
                status_regions: 'success',
                message_regions: payload.message,
            };
        case PENDING_REGIONS:
            return  {
                ...state,
                status_regions: 'pending',
                message_regions: payload.message,
            };
        case FAIL_REGIONS:
            return  {
                ...state,
                status_regions: 'fail',
                message_regions: payload.message,
            };

        case SUCCESS_DEPARTEMENTS:
            return  {
                ...state,
                status_departements: 'success',
                message_departements: payload.message,
            };
        case PENDING_DEPARTEMENTS:
            return  {
                ...state,
                status_departements: 'pending',
                message_departements: payload.message,
            };
        case FAIL_DEPARTEMENTS:
            return  {
                ...state,
                status_departements: 'fail',
                message_departements: payload.message,
            };

        case SUCCESS_ARRONDISSEMENTS:
            return  {
                ...state,
                status_arrondissements: 'success',
                message_arrondissements: payload.message,
            };
        case PENDING_ARRONDISSEMENTS:
            return  {
                ...state,
                status_arrondissements: 'pending',
                message_arrondissements: payload.message,
            };
        case FAIL_ARRONDISSEMENTS:
            return  {
                ...state,
                status_arrondissements: 'fail',
                message_arrondissements: payload.message,
            };

        case SUCCESS_ETABLISSEMENTS_ITEM:
            return  {
                ...state,
                status_etablissement_item: 'success',
                message_etablissement_item: payload.message,
            };
        case PENDING_ETABLISSEMENTS_ITEM:
            return  {
                ...state,
                status_etablissement_item: 'pending',
                message_etablissement_item: payload.message,
            };
        case FAIL_ETABLISSEMENTS_ITEM:
            return  {
                ...state,
                status_etablissement_item: 'fail',
                message_etablissement_item: payload.message,
            };

        default:
            return state;
    }
}
